// File: src/serviceWorkerRegistration.ts
export function register(): void {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      // Use the public URL environment variable
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      navigator.serviceWorker.register(swUrl)
        .then(registration => {
          console.log('SW registered: ', registration);
        })
        .catch(registrationError => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  }
}

// ---